<template>
  <div class="contactus">
    <div class="d-flex justify-end pa-5 pb-0">
      <v-icon @click="closedialog()">mdi-close</v-icon>
    </div>
    <div class="pa-5">
      <div class="d-flex justify-center">
        <span class="text_heading"> Sign up today for the </span>
      </div>
      <div class="d-flex justify-center">
        <span class="text_heading_1"> IBA Newsletter! </span>
      </div>

      <div class="px-7">
        <form @submit.prevent="submit">
          <div
            class="form-group pt-1 mb-2"
            :class="{ 'form-group--error': $v.form.email.$error }"
          >
            <v-text-field
              hide-details
              label="Email address "
              v-model="form.email"
              placeholder="youremail@company.com"
              :error="$v.form.email.$error"
            ></v-text-field>
            <div></div>

            <div class="v-application .error" v-if="$v.form.email.$error">
              <span class="text_warnig"> Please enter email name</span>
            </div>
          </div>
          <div
            class="form-group pt-1 mb-2"
            :class="{ 'form-group--error': $v.form.fname.$error }"
          >
            <v-text-field
              hide-details
              label="First name "
              v-model="form.fname"
              :error="$v.form.fname.$error"
            ></v-text-field>
            <div></div>

            <div class="v-application .error" v-if="$v.form.fname.$error">
              <span class="text_warnig"> Please enter first name</span>
            </div>
          </div>
          <div
            class="form-group pt-1 mb-2"
            :class="{ 'form-group--error': $v.form.lname.$error }"
          >
            <v-text-field
              hide-details
              label="Last name "
              v-model="form.lname"
              :error="$v.form.lname.$error"
            ></v-text-field>
            <div></div>

            <div class="v-application .error" v-if="$v.form.lname.$error">
              <span class="text_warnig"> Please enter last name</span>
            </div>
          </div>

          <div
            class="form-group pt-1 mb-2"
            :class="{ 'form-group--error': $v.form.country.$error }"
          >
            <v-select
              hide-details
              label="Country"
              :items="GetCountry.data.map((x) => x.name.common)"
              v-model="form.country"
              :error="$v.form.country.$error"
            ></v-select>
            <div></div>

            <div class="v-application .error" v-if="$v.form.country.$error">
              <span class="text_warnig"> Please enter country</span>
            </div>
          </div>
          <v-select
            label="How did you find us?"
            single-line
            :items="items"
            hide-details
            class="my-4"
            v-model="howFindUs"
          ></v-select>
          <v-select
            v-model="ageRange"
            :items="agerageArray"
            :menu-props="{ maxHeight: '400' }"
            label="Age Range"
            single
            hide-details
            persistent-hint
          ></v-select>
          <v-select
            label="Language "
            v-model="form.Language"
            class="my-4" multiple
            :items="languageArray"
          ></v-select>
          <div>
            <div>Newsletter Subscriptions</div>
            <v-checkbox
              v-model="SubscriptionsCheckbox"
              class="mt-2"
              value="English"
            >
              <template v-slot:label>
                <div>IBA: English</div>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="SubscriptionsCheckbox"
              class="mt-0"
              value="German"
            >
              <template v-slot:label>
                <div>IBA: German</div>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="SubscriptionsCheckbox"
              class="mt-0"
              value="Portuguese"
            >
              <template v-slot:label>
                <div>IBA: Portuguese</div>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="SubscriptionsCheckbox"
              class="mt-0"
              value="Japanese"
            >
              <template v-slot:label>
                <div>IBA: Japanese</div>
              </template>
            </v-checkbox>
          </div>
         
          <v-btn
            depressed
            class="button mt-5 mb-11"
            block
            height="50"
            color="primary"
            type="button"
            @click="submit"
          >
            <span v-if="this.btnloader != true">Subscribe</span>
            <v-progress-circular
              indeterminate
              v-show="btnloader"
              color="white"
              size="20"
            ></v-progress-circular>
          </v-btn>
        </form>
      </div>
      <div class="d-flex justify-center">
        <b> Worried about your privacy?</b>
      </div>
      <div class="d-flex justify-center">
        <span class="text_stying"
          >Read our
          <router-link to="/privacypolicy"> Privacy Policy </router-link>to see
          how we protect your data.</span
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts">
// import ChangeLanguageComponent from "../../components/HomePage/ChangeLanguage.Component.vue";
// import languageObject from "../../utils/index";
import { defineComponent } from "vue";
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { Newsletter } from "../../Models/NewsLetter/Newsletter";

export default defineComponent({
  name: "ContactUsComponent",
  // components: {ChangeLanguageComponent},
  mixins: [validationMixin],
  data() {
    return {
      // languageObject,
      languageArray: ["English", "Japanese", "German", "Portuguese"],
      SubscriptionsCheckbox: ["English"],
      ageRange: [],
      howFindUs: [],
      agerageArray: ["0-18", "19-35", "36-54", "55-70", "71-90", "90+"],
      items: [
        "Previous Student",
        "Instructor Promotion",
        "Family / Friend",
        "Article",
        "Flayer",
        "Online Newsletter",
        "IBA Website",
        "Facebook",
        "Twitter",
        "Other",
      ],

      signupdialog: false,
      errorIcon: false as boolean,
      show1: false as boolean,
      btnloader: false,
      form: {
        email: "" as string,
        fname: "" as string,
        lname: "" as string,
        country: "" as string,
        Language: [],
        IsMember: true,
        IsGeneral: true,
        required,
      },
      submitStatus: "" as string,
      formNewsLetter: {} as Newsletter,
    };
  },

  validations: {
    form: {
      email: { required, email },
      fname: { required },
      lname: { required },
      country: { required },
    },
  },
  computed: {
    ...mapGetters(["GetCountry", 
    // "getFlag"
  ]),
  },
  mounted() {
    this.$store.dispatch("GetAllCountries");
  },
  methods: {
    closedialog() {
      this.$store.dispatch("ToggleContact", false);
      this.form.email = "";
      this.form.fname = "";
      this.form.lname = "";
      this.form.country = "";
      this.ageRange = [];
      this.howFindUs = [];
      this.SubscriptionsCheckbox = [];
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        this.btnloader = true;
        setTimeout(() => {
          this.submitStatus = "OK";
          this.btnloader = false;
          this.formNewsLetter.FirstName = this.form.fname;
          this.formNewsLetter.LastName = this.form.lname;
          this.formNewsLetter.Email = this.form.email;
          this.formNewsLetter.WhereYoufind = this.howFindUs.toString();
          this.formNewsLetter.AgeRange = this.ageRange.toString();
          // this.formNewsLetter.Country = this.form.country.toString();
          this.formNewsLetter.Language = this.form.Language;
          this.formNewsLetter.IsMember = this.form.IsMember;
          this.formNewsLetter.IsGeneral = this.form.IsGeneral;
          this.$store.dispatch("ToggleContact", false);
          this.$store.dispatch("AddAllMembership", this.formNewsLetter);
        }, 1500);
      }
    },
  },
});
</script>

<style></style>
